import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/(all)/mobile-app/template.tsx");
